import React from 'react';
import { Navigation } from '../components/landing/Navigation';
import { HeroSection } from '../components/landing/HeroSection';
import { WhatIsSection } from '../components/landing/WhatIsSection';
import { SubjectsGrid } from '../components/landing/SubjectsGrid';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { FeaturesGrid } from '../components/landing/FeaturesGrid';
import { PortalsSection } from '../components/landing/PortalsSection';
import { InvestorsSection } from '../components/landing/InvestorsSection';
import { ArchitectureSection } from '../components/landing/ArchitectureSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FooterSection } from '../components/landing/FooterSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-262">
      <Navigation data-id="element-263" />

      <main data-id="element-264">
        <HeroSection data-id="element-265" />
        <WhatIsSection data-id="element-266" />
        <SubjectsGrid data-id="element-267" />
        <HowItWorksSection data-id="element-268" />
        <FeaturesGrid data-id="element-269" />
        <PortalsSection data-id="element-270" />
        <InvestorsSection data-id="element-271" />
        <ArchitectureSection data-id="element-272" />
        <FAQSection data-id="element-273" />
      </main>

      <FooterSection data-id="element-274" />
    </div>;
}